/**
 * /dashboard means something different depending on who you are.
 *
 * Admins get the enrollment inbox; families get their own. Both are "the things
 * that need you", which is why they share a route rather than a component —
 * a parent used to land on the admin dashboard and see an empty shell, because
 * the query behind it is admins-only.
 */
import { useOutletContext } from 'react-router-dom';
import type { AppLayoutContext } from '~/types';
import { roleGroupFor } from '~/components/Sidebar/sidebarLayout';
import Dashboard from './Dashboard';
import ParentDashboard from '../ParentDashboard/ParentDashboard';

export default function DashboardRoute() {
  const { roleContext } = useOutletContext<AppLayoutContext>();

  return roleGroupFor(roleContext?.selectedRole) === 'family'
    ? <ParentDashboard />
    : <Dashboard />;
}
